import { Layout } from "../layout";
import styled from 'styled-components';
import { WegetFormField } from "./wegets/weget-form-field";

const StyledContainer = styled.div`
    background-color: var(--backgroundField);
    min-height:100vh;
    padding-bottom: 200px;
`;

export function MainView(props) {
    return (
        <>
            <Layout>
                <StyledContainer>
                    <WegetFormField

                    />
                </StyledContainer>
            </Layout>
        </>
    );
}